module.exports = __webpack_public_path__ + "static/media/abstraction-point.2780ad66.svg";